import { createAsyncThunk } from "@reduxjs/toolkit";
import { bffApi, type SourcingEventDto, type SourcingEventFieldSourceDto } from "../../autogen/bff-api";
import { readSettled } from "../redux/untilSettled";

type CreationProgressData = { event: SourcingEventDto; fields: SourcingEventFieldSourceDto[] };

export const fetchSettledCreationProgress = createAsyncThunk<CreationProgressData, { procurementId: string }>(
  "creationProgress/fetchSettled",
  async ({ procurementId }, thunk) => {
    const [event, sources] = await Promise.all([
      readSettled(bffApi.endpoints.getSourcingEvent, { eventId: procurementId, recordView: false }, thunk),
      readSettled(bffApi.endpoints.listSourcingEventFieldSources, { eventId: procurementId }, thunk),
    ]);
    return { event, fields: sources.fields };
  },
);
